/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_zone_1 = require('./zone/ng_zone');
var lang_1 = require('./facade/lang');
var di_1 = require('./di');
var application_tokens_1 = require('./application_tokens');
var async_1 = require('./facade/async');
var collection_1 = require('./facade/collection');
var testability_1 = require('./testability/testability');
var component_resolver_1 = require('./linker/component_resolver');
var exceptions_1 = require('./facade/exceptions');
var console_1 = require('./console');
var profile_1 = require('./profile/profile');
function createNgZone() {
  return new ng_zone_1.NgZone({enableLongStackTrace: lang_1.assertionsEnabled()});
}
exports.createNgZone = createNgZone;
var _platform;
var _inPlatformCreate = false;
function createPlatform(injector) {
  if (_inPlatformCreate) {
    throw new exceptions_1.BaseException('Already creating a platform...');
  }
  if (lang_1.isPresent(_platform) && !_platform.disposed) {
    throw new exceptions_1.BaseException("There can be only one platform. Destroy the previous one to create a new one.");
  }
  lang_1.lockMode();
  _inPlatformCreate = true;
  try {
    _platform = injector.get(PlatformRef);
  } finally {
    _inPlatformCreate = false;
  }
  return _platform;
}
exports.createPlatform = createPlatform;
function assertPlatform(requiredToken) {
  var platform = getPlatform();
  if (lang_1.isBlank(platform)) {
    throw new exceptions_1.BaseException('Not platform exists!');
  }
  if (lang_1.isPresent(platform) && lang_1.isBlank(platform.injector.get(requiredToken, null))) {
    throw new exceptions_1.BaseException('A platform with a different configuration has been created. Please destroy it first.');
  }
  return platform;
}
exports.assertPlatform = assertPlatform;
function disposePlatform() {
  if (lang_1.isPresent(_platform) && !_platform.disposed) {
    _platform.dispose();
  }
}
exports.disposePlatform = disposePlatform;
function getPlatform() {
  return lang_1.isPresent(_platform) && !_platform.disposed ? _platform : null;
}
exports.getPlatform = getPlatform;
function coreBootstrap(injector, componentFactory) {
  var appRef = injector.get(ApplicationRef);
  return appRef.bootstrap(componentFactory);
}
exports.coreBootstrap = coreBootstrap;
function coreLoadAndBootstrap(injector, componentType) {
  var appRef = injector.get(ApplicationRef);
  return appRef.run(function() {
    var componentResolver = injector.get(component_resolver_1.ComponentResolver);
    return async_1.PromiseWrapper.all([componentResolver.resolveComponent(componentType), appRef.waitForAsyncInitializers()]).then(function(arr) {
      return appRef.bootstrap(arr[0]);
    });
  });
}
exports.coreLoadAndBootstrap = coreLoadAndBootstrap;
var PlatformRef = (function() {
  function PlatformRef() {}
  Object.defineProperty(PlatformRef.prototype, "injector", {
    get: function() {
      throw exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(PlatformRef.prototype, "disposed", {
    get: function() {
      throw exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  return PlatformRef;
}());
exports.PlatformRef = PlatformRef;
var PlatformRef_ = (function(_super) {
  __extends(PlatformRef_, _super);
  function PlatformRef_(_injector) {
    _super.call(this);
    this._injector = _injector;
    this._applications = [];
    this._disposeListeners = [];
    this._disposed = false;
    if (!_inPlatformCreate) {
      throw new exceptions_1.BaseException('Platforms have to be created via `createPlatform`!');
    }
    var inits = _injector.get(application_tokens_1.PLATFORM_INITIALIZER, null);
    if (lang_1.isPresent(inits))
      inits.forEach(function(init) {
        return init();
      });
  }
  PlatformRef_.prototype.registerDisposeListener = function(dispose) {
    this._disposeListeners.push(dispose);
  };
  Object.defineProperty(PlatformRef_.prototype, "injector", {
    get: function() {
      return this._injector;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlatformRef_.prototype, "disposed", {
    get: function() {
      return this._disposed;
    },
    enumerable: true,
    configurable: true
  });
  PlatformRef_.prototype.addApplication = function(appRef) {
    this._applications.push(appRef);
  };
  PlatformRef_.prototype.dispose = function() {
    collection_1.ListWrapper.clone(this._applications).forEach(function(app) {
      return app.dispose();
    });
    this._disposeListeners.forEach(function(dispose) {
      return dispose();
    });
    this._disposed = true;
  };
  PlatformRef_.prototype._applicationDisposed = function(app) {
    collection_1.ListWrapper.remove(this._applications, app);
  };
  PlatformRef_.decorators = [{type: di_1.Injectable}];
  PlatformRef_.ctorParameters = [{type: di_1.Injector}];
  return PlatformRef_;
}(PlatformRef));
exports.PlatformRef_ = PlatformRef_;
var ApplicationRef = (function() {
  function ApplicationRef() {}
  Object.defineProperty(ApplicationRef.prototype, "injector", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ApplicationRef.prototype, "zone", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ApplicationRef.prototype, "componentTypes", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  return ApplicationRef;
}());
exports.ApplicationRef = ApplicationRef;
var ApplicationRef_ = (function(_super) {
  __extends(ApplicationRef_, _super);
  function ApplicationRef_(_platform, _zone, _injector) {
    var _this = this;
    _super.call(this);
    this._platform = _platform;
    this._zone = _zone;
    this._injector = _injector;
    this._bootstrapListeners = [];
    this._disposeListeners = [];
    this._rootComponents = [];
    this._rootComponentTypes = [];
    this._changeDetectorRefs = [];
    this._runningTick = false;
    this._enforceNoNewChanges = false;
    var zone = _injector.get(ng_zone_1.NgZone);
    this._enforceNoNewChanges = lang_1.assertionsEnabled();
    zone.run(function() {
      _this._exceptionHandler = _injector.get(exceptions_1.ExceptionHandler);
    });
    this._asyncInitDonePromise = this.run(function() {
      var inits = _injector.get(application_tokens_1.APP_INITIALIZER, null);
      var asyncInitResults = [];
      var asyncInitDonePromise;
      if (lang_1.isPresent(inits)) {
        for (var i = 0; i < inits.length; i++) {
          var initResult = inits[i]();
          if (lang_1.isPromise(initResult)) {
            asyncInitResults.push(initResult);
          }
        }
      }
      if (asyncInitResults.length > 0) {
        asyncInitDonePromise = async_1.PromiseWrapper.all(asyncInitResults).then(function(_) {
          return _this._asyncInitDone = true;
        });
        _this._asyncInitDone = false;
      } else {
        _this._asyncInitDone = true;
        asyncInitDonePromise = async_1.PromiseWrapper.resolve(true);
      }
      return asyncInitDonePromise;
    });
    async_1.ObservableWrapper.subscribe(zone.onError, function(error) {
      _this._exceptionHandler.call(error.error, error.stackTrace);
    });
    async_1.ObservableWrapper.subscribe(this._zone.onMicrotaskEmpty, function(_) {
      _this._zone.run(function() {
        _this.tick();
      });
    });
  }
  ApplicationRef_.prototype.registerBootstrapListener = function(listener) {
    this._bootstrapListeners.push(listener);
  };
  ApplicationRef_.prototype.registerDisposeListener = function(dispose) {
    this._disposeListeners.push(dispose);
  };
  ApplicationRef_.prototype.registerChangeDetector = function(changeDetector) {
    this._changeDetectorRefs.push(changeDetector);
  };
  ApplicationRef_.prototype.unregisterChangeDetector = function(changeDetector) {
    collection_1.ListWrapper.remove(this._changeDetectorRefs, changeDetector);
  };
  ApplicationRef_.prototype.waitForAsyncInitializers = function() {
    return this._asyncInitDonePromise;
  };
  ApplicationRef_.prototype.run = function(callback) {
    var _this = this;
    var zone = this.injector.get(ng_zone_1.NgZone);
    var result;
    var completer = async_1.PromiseWrapper.completer();
    zone.run(function() {
      try {
        result = callback();
        if (lang_1.isPromise(result)) {
          async_1.PromiseWrapper.then(result, function(ref) {
            completer.resolve(ref);
          }, function(err, stackTrace) {
            completer.reject(err, stackTrace);
            _this._exceptionHandler.call(err, stackTrace);
          });
        }
      } catch (e) {
        _this._exceptionHandler.call(e, e.stack);
        throw e;
      }
    });
    return lang_1.isPromise(result) ? completer.promise : result;
  };
  ApplicationRef_.prototype.bootstrap = function(componentFactory) {
    var _this = this;
    if (!this._asyncInitDone) {
      throw new exceptions_1.BaseException('Cannot bootstrap as there are still asynchronous initializers running. Wait for them using waitForAsyncInitializers().');
    }
    return this.run(function() {
      _this._rootComponentTypes.push(componentFactory.componentType);
      var compRef = componentFactory.create(_this._injector, [], componentFactory.selector);
      compRef.onDestroy(function() {
        _this._unloadComponent(compRef);
      });
      var testability = compRef.injector.get(testability_1.Testability, null);
      if (lang_1.isPresent(testability)) {
        compRef.injector.get(testability_1.TestabilityRegistry).registerApplication(compRef.location.nativeElement, testability);
      }
      _this._loadComponent(compRef);
      var c = _this._injector.get(console_1.Console);
      if (lang_1.assertionsEnabled()) {
        c.log("Angular 2 is running in the development mode. Call enableProdMode() to enable the production mode.");
      }
      return compRef;
    });
  };
  ApplicationRef_.prototype._loadComponent = function(componentRef) {
    this._changeDetectorRefs.push(componentRef.changeDetectorRef);
    this.tick();
    this._rootComponents.push(componentRef);
    this._bootstrapListeners.forEach(function(listener) {
      return listener(componentRef);
    });
  };
  ApplicationRef_.prototype._unloadComponent = function(componentRef) {
    if (!collection_1.ListWrapper.contains(this._rootComponents, componentRef)) {
      return;
    }
    this.unregisterChangeDetector(componentRef.changeDetectorRef);
    collection_1.ListWrapper.remove(this._rootComponents, componentRef);
  };
  Object.defineProperty(ApplicationRef_.prototype, "injector", {
    get: function() {
      return this._injector;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApplicationRef_.prototype, "zone", {
    get: function() {
      return this._zone;
    },
    enumerable: true,
    configurable: true
  });
  ApplicationRef_.prototype.tick = function() {
    if (this._runningTick) {
      throw new exceptions_1.BaseException("ApplicationRef.tick is called recursively");
    }
    var s = ApplicationRef_._tickScope();
    try {
      this._runningTick = true;
      this._changeDetectorRefs.forEach(function(detector) {
        return detector.detectChanges();
      });
      if (this._enforceNoNewChanges) {
        this._changeDetectorRefs.forEach(function(detector) {
          return detector.checkNoChanges();
        });
      }
    } finally {
      this._runningTick = false;
      profile_1.wtfLeave(s);
    }
  };
  ApplicationRef_.prototype.dispose = function() {
    collection_1.ListWrapper.clone(this._rootComponents).forEach(function(ref) {
      return ref.destroy();
    });
    this._disposeListeners.forEach(function(dispose) {
      return dispose();
    });
    this._platform._applicationDisposed(this);
  };
  Object.defineProperty(ApplicationRef_.prototype, "componentTypes", {
    get: function() {
      return this._rootComponentTypes;
    },
    enumerable: true,
    configurable: true
  });
  ApplicationRef_._tickScope = profile_1.wtfCreateScope('ApplicationRef#tick()');
  ApplicationRef_.decorators = [{type: di_1.Injectable}];
  ApplicationRef_.ctorParameters = [{type: PlatformRef_}, {type: ng_zone_1.NgZone}, {type: di_1.Injector}];
  return ApplicationRef_;
}(ApplicationRef));
exports.ApplicationRef_ = ApplicationRef_;
exports.PLATFORM_CORE_PROVIDERS = [PlatformRef_, ({
  provide: PlatformRef,
  useExisting: PlatformRef_
})];
exports.APPLICATION_CORE_PROVIDERS = [{
  provide: ng_zone_1.NgZone,
  useFactory: createNgZone,
  deps: []
}, ApplicationRef_, {
  provide: ApplicationRef,
  useExisting: ApplicationRef_
}];
